import type {AjaxActionType, CategoryItemsType} from 'constants/flow/flowTypes';
import {CATEGORY} from 'constants/actions';
import {categoryFilterAdapter} from 'reducers/category/categoryFilterAdapter/categoryFilterAdapter';

export const initialState = {
    items: [],
};

type StateType = {
    items: Array,
};

/**
 * Get filters
 * @param {StateType} state  - Current state
 * @param {AjaxActionType} action - Received action
 * @returns {CategoryItemsType} - status filter
 */
export default function filters(
    state: StateType = initialState,
    action: AjaxActionType,
): CategoryItemsType | {} {
    switch (action.type) {
        case `${CATEGORY.GET_FILTERS_CATEGORY}_FULFILLED`:
            return {
                ...state,
                items: categoryFilterAdapter(action.payload.data),
                status: 'fulfilled',
            };
        case `${CATEGORY.GET_FILTERS_CATEGORY}_PENDING`:
            return {...state, status: 'pending'};
        case `${CATEGORY.GET_FILTERS_CATEGORY}_REJECTED`:
            return {...action.payload.response, status: 'rejected'};
        default:
            return state;
    }
}
